function Bn(e, t) {
  return toString.call(e) === `[object ${t}]`;
}
function Oe(e = B.router.currentRoute.value) {
  var r;
  const t = e.meta.nav;
  let n = e.matched.map((s) => s.meta.title).join("/");
  if (t && ((r = e.params) != null && r.id)) {
    const s = t.filter((i) => i.id === e.params.id)[0];
    s && (n += "/" + s.title);
  }
  return n;
}
function Gn() {
  const { id: e, name: t, businessType: n, deptId: r, userTitle: s } = B.userInfo;
  return {
    user_id: e,
    user_name: t,
    bz_type: n,
    dept_id: r,
    user_title: s
  };
}
function Qn() {
  const e = [];
  return [
    ...Array.from(document.getElementsByClassName("ant-modal-wrap")),
    ...Array.from(document.getElementsByClassName("ant-drawer"))
  ].forEach((n) => {
    const r = window.getComputedStyle(n);
    if (r.getPropertyValue("display") === "none") return;
    const s = n.querySelector(
      ".ant-modal-title, .ant-drawer-title, .ant-modal-confirm-title"
    ), i = s.querySelector("h3"), c = (i == null ? void 0 : i.innerText) || s.innerText;
    e.push({
      zIndex: Number(r.getPropertyValue("z-index")),
      text: c
    });
  }), e.sort((n, r) => n.zIndex - r.zIndex), e.map((n) => n.text);
}
const Zn = [
  "/order/page/new",
  "/order/page",
  "order/search/kf",
  "order/search/ct",
  "order/search/sp"
], Xn = ["/order/detail/get", "/order/detail/overview"], er = [
  "/order/page/nodeStatistics/new",
  "/order/page/nodeStatistics"
];
function mi(e) {
  var t;
  try {
    const n = e.res;
    if (er.includes(e.url)) {
      const r = Oe();
      n != null && n.nodeTimeliness && !Ce.get(r) && Ce.set(r, {
        nodeTimeliness: n.nodeTimeliness,
        title: ""
      });
    }
    if (Zn.includes(e.url)) {
      e.res.list.forEach((o) => {
        const l = o.node, p = o.orderNoInfo.orderNo + "", _ = o.orderType, a = o.orderOutline, g = o.productCategory1StId || o.productCategory1stId;
        ft.set(p, {
          order_oper: !0,
          order_no: p,
          order_pc1st: g,
          order_type: _,
          order_warranty: a,
          order_node: l
        });
      });
      const r = Oe(), s = e.params.nodeTimelinesType, i = Ce.get(r), c = (t = i == null ? void 0 : i.nodeTimeliness.filter(
        (o) => o.type === s
      )[0]) == null ? void 0 : t.title;
      c && (i.title && i.title !== c && qn({
        func_menu: `${r}${c ? `/${c}` : ""}`,
        func_source_menu: `${r}${i.title ? `/${i.title}` : ""}`
      }), Ce.set(r, {
        nodeTimeliness: i.nodeTimeliness,
        title: c
      }));
    }
    if (Xn.includes(e.url)) {
      const r = n.nodeProgress.node, s = n.headDetail.head.orderNo + "", i = n.orderType, c = n.headDetail.head.orderOutline, o = n.productCategoryId;
      ft.set(s, {
        order_oper: !0,
        order_no: s,
        order_pc1st: o,
        order_type: i,
        order_warranty: c,
        order_node: r
      });
    }
  } catch {
  }
}
function tr() {
  B.router.afterEach((e, t) => {
    t.matched.length > 0 && qn({
      func_menu: Oe(e),
      func_source_menu: Oe(t)
    });
  });
}
let sn = {};
function nr() {
  sn = B.createAxios({
    requestOptions: {
      urlPrefix: "/dwh-sync",
      errorMessageMode: "none"
    }
  });
}
function rr(e) {
  if (B.isLogin)
    return sn.post(
      {
        url: "/eventClick/uploadNew",
        data: e
      },
      {
        hideLoading: !0,
        noFormatData: !0
      }
    );
}
/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function sr(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const Fe = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Se = () => {
}, ir = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), fe = Object.assign, or = Object.prototype.hasOwnProperty, Dt = (e, t) => or.call(e, t), M = Array.isArray, Ne = (e) => dt(e) === "[object Map]", cr = (e) => dt(e) === "[object Set]", A = (e) => typeof e == "function", re = (e) => typeof e == "string", ze = (e) => typeof e == "symbol", Y = (e) => e !== null && typeof e == "object", ar = (e) => (Y(e) || A(e)) && A(e.then) && A(e.catch), lr = Object.prototype.toString, dt = (e) => lr.call(e), on = (e) => dt(e).slice(8, -1), ur = (e) => dt(e) === "[object Object]", Ct = (e) => re(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, cn = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, an = cn((e) => e.charAt(0).toUpperCase() + e.slice(1)), fr = cn(
  (e) => e ? `on${an(e)}` : ""
), ue = (e, t) => !Object.is(e, t);
let qt;
const pt = () => qt || (qt = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function At(e) {
  if (M(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], s = re(r) ? gr(r) : At(r);
      if (s)
        for (const i in s)
          t[i] = s[i];
    }
    return t;
  } else if (re(e) || Y(e))
    return e;
}
const dr = /;(?![^(]*\))/g, pr = /:([^]+)/, hr = /\/\*[^]*?\*\//g;
function gr(e) {
  const t = {};
  return e.replace(hr, "").split(dr).forEach((n) => {
    if (n) {
      const r = n.split(pr);
      r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
}
function jt(e) {
  let t = "";
  if (re(e))
    t = e;
  else if (M(e))
    for (let n = 0; n < e.length; n++) {
      const r = jt(e[n]);
      r && (t += r + " ");
    }
  else if (Y(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
/**
* @vue/reactivity v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function se(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let D;
const _t = /* @__PURE__ */ new WeakSet();
class mr {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0;
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, _t.has(this) && (_t.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || un(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Bt(this), fn(this);
    const t = D, n = G;
    D = this, G = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && D !== this && se(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), dn(this), D = t, G = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Ft(t);
      this.deps = this.depsTail = void 0, Bt(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? _t.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Ot(this) && this.run();
  }
  get dirty() {
    return Ot(this);
  }
}
let ln = 0, je, ke;
function un(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = ke, ke = e;
    return;
  }
  e.next = je, je = e;
}
function kt() {
  ln++;
}
function Lt() {
  if (--ln > 0)
    return;
  if (ke) {
    let t = ke;
    for (ke = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; je; ) {
    let t = je;
    for (je = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (r) {
          e || (e = r);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function fn(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function dn(e) {
  let t, n = e.depsTail, r = n;
  for (; r; ) {
    const s = r.prevDep;
    r.version === -1 ? (r === n && (n = s), Ft(r), _r(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = s;
  }
  e.deps = t, e.depsTail = n;
}
function Ot(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (pn(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function pn(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Pe) || (e.globalVersion = Pe, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Ot(e))))
    return;
  e.flags |= 2;
  const t = e.dep, n = D, r = G;
  D = e, G = !0;
  try {
    fn(e);
    const s = e.fn(e._value);
    (t.version === 0 || ue(s, e._value)) && (e.flags |= 128, e._value = s, t.version++);
  } catch (s) {
    throw t.version++, s;
  } finally {
    D = n, G = r, dn(e), e.flags &= -3;
  }
}
function Ft(e, t = !1) {
  const { dep: n, prevSub: r, nextSub: s } = e;
  if (r && (r.nextSub = s, e.prevSub = void 0), s && (s.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = s), n.subs === e && (n.subs = r, !r && n.computed)) {
    n.computed.flags &= -5;
    for (let i = n.computed.deps; i; i = i.nextDep)
      Ft(i, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function _r(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let G = !0;
const hn = [];
function Te() {
  hn.push(G), G = !1;
}
function $e() {
  const e = hn.pop();
  G = e === void 0 ? !0 : e;
}
function Bt(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = D;
    D = void 0;
    try {
      t();
    } finally {
      D = n;
    }
  }
}
let Pe = 0;
class vr {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class ht {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!D || !G || D === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== D)
      n = this.activeLink = new vr(D, this), D.deps ? (n.prevDep = D.depsTail, D.depsTail.nextDep = n, D.depsTail = n) : D.deps = D.depsTail = n, gn(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const r = n.nextDep;
      r.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = r), n.prevDep = D.depsTail, n.nextDep = void 0, D.depsTail.nextDep = n, D.depsTail = n, D.deps === n && (D.deps = r);
    }
    return process.env.NODE_ENV !== "production" && D.onTrack && D.onTrack(
      fe(
        {
          effect: D
        },
        t
      )
    ), n;
  }
  trigger(t) {
    this.version++, Pe++, this.notify(t);
  }
  notify(t) {
    kt();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let n = this.subsHead; n; n = n.nextSub)
          n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
            fe(
              {
                effect: n.sub
              },
              t
            )
          );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      Lt();
    }
  }
}
function gn(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let r = t.deps; r; r = r.nextDep)
        gn(r);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const rt = /* @__PURE__ */ new WeakMap(), me = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), Tt = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), He = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function K(e, t, n) {
  if (G && D) {
    let r = rt.get(e);
    r || rt.set(e, r = /* @__PURE__ */ new Map());
    let s = r.get(n);
    s || (r.set(n, s = new ht()), s.map = r, s.key = n), process.env.NODE_ENV !== "production" ? s.track({
      target: e,
      type: t,
      key: n
    }) : s.track();
  }
}
function ae(e, t, n, r, s, i) {
  const c = rt.get(e);
  if (!c) {
    Pe++;
    return;
  }
  const o = (l) => {
    l && (process.env.NODE_ENV !== "production" ? l.trigger({
      target: e,
      type: t,
      key: n,
      newValue: r,
      oldValue: s,
      oldTarget: i
    }) : l.trigger());
  };
  if (kt(), t === "clear")
    c.forEach(o);
  else {
    const l = M(e), p = l && Ct(n);
    if (l && n === "length") {
      const _ = Number(r);
      c.forEach((a, g) => {
        (g === "length" || g === He || !ze(g) && g >= _) && o(a);
      });
    } else
      switch ((n !== void 0 || c.has(void 0)) && o(c.get(n)), p && o(c.get(He)), t) {
        case "add":
          l ? p && o(c.get("length")) : (o(c.get(me)), Ne(e) && o(c.get(Tt)));
          break;
        case "delete":
          l || (o(c.get(me)), Ne(e) && o(c.get(Tt)));
          break;
        case "set":
          Ne(e) && o(c.get(me));
          break;
      }
  }
  Lt();
}
function yr(e, t) {
  const n = rt.get(e);
  return n && n.get(t);
}
function we(e) {
  const t = E(e);
  return t === e ? t : (K(t, "iterate", He), z(e) ? t : t.map(H));
}
function Pt(e) {
  return K(e = E(e), "iterate", He), e;
}
const wr = {
  __proto__: null,
  [Symbol.iterator]() {
    return vt(this, Symbol.iterator, H);
  },
  concat(...e) {
    return we(this).concat(
      ...e.map((t) => M(t) ? we(t) : t)
    );
  },
  entries() {
    return vt(this, "entries", (e) => (e[1] = H(e[1]), e));
  },
  every(e, t) {
    return X(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return X(this, "filter", e, t, (n) => n.map(H), arguments);
  },
  find(e, t) {
    return X(this, "find", e, t, H, arguments);
  },
  findIndex(e, t) {
    return X(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return X(this, "findLast", e, t, H, arguments);
  },
  findLastIndex(e, t) {
    return X(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return X(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return yt(this, "includes", e);
  },
  indexOf(...e) {
    return yt(this, "indexOf", e);
  },
  join(e) {
    return we(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return yt(this, "lastIndexOf", e);
  },
  map(e, t) {
    return X(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Ie(this, "pop");
  },
  push(...e) {
    return Ie(this, "push", e);
  },
  reduce(e, ...t) {
    return Gt(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Gt(this, "reduceRight", e, t);
  },
  shift() {
    return Ie(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return X(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Ie(this, "splice", e);
  },
  toReversed() {
    return we(this).toReversed();
  },
  toSorted(e) {
    return we(this).toSorted(e);
  },
  toSpliced(...e) {
    return we(this).toSpliced(...e);
  },
  unshift(...e) {
    return Ie(this, "unshift", e);
  },
  values() {
    return vt(this, "values", H);
  }
};
function vt(e, t, n) {
  const r = Pt(e), s = r[t]();
  return r !== e && !z(e) && (s._next = s.next, s.next = () => {
    const i = s._next();
    return i.value && (i.value = n(i.value)), i;
  }), s;
}
const br = Array.prototype;
function X(e, t, n, r, s, i) {
  const c = Pt(e), o = c !== e && !z(e), l = c[t];
  if (l !== br[t]) {
    const a = l.apply(e, i);
    return o ? H(a) : a;
  }
  let p = n;
  c !== e && (o ? p = function(a, g) {
    return n.call(this, H(a), g, e);
  } : n.length > 2 && (p = function(a, g) {
    return n.call(this, a, g, e);
  }));
  const _ = l.call(c, p, r);
  return o && s ? s(_) : _;
}
function Gt(e, t, n, r) {
  const s = Pt(e);
  let i = n;
  return s !== e && (z(e) ? n.length > 3 && (i = function(c, o, l) {
    return n.call(this, c, o, l, e);
  }) : i = function(c, o, l) {
    return n.call(this, c, H(o), l, e);
  }), s[t](i, ...r);
}
function yt(e, t, n) {
  const r = E(e);
  K(r, "iterate", He);
  const s = r[t](...n);
  return (s === -1 || s === !1) && st(n[0]) ? (n[0] = E(n[0]), r[t](...n)) : s;
}
function Ie(e, t, n = []) {
  Te(), kt();
  const r = E(e)[t].apply(e, n);
  return Lt(), $e(), r;
}
const Er = /* @__PURE__ */ sr("__proto__,__v_isRef,__isVue"), mn = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(ze)
);
function Sr(e) {
  ze(e) || (e = String(e));
  const t = E(this);
  return K(t, "has", e), t.hasOwnProperty(e);
}
class _n {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, r) {
    if (n === "__v_skip") return t.__v_skip;
    const s = this._isReadonly, i = this._isShallow;
    if (n === "__v_isReactive")
      return !s;
    if (n === "__v_isReadonly")
      return s;
    if (n === "__v_isShallow")
      return i;
    if (n === "__v_raw")
      return r === (s ? i ? Ir : wn : i ? Vr : yn).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(r) ? t : void 0;
    const c = M(t);
    if (!s) {
      let l;
      if (c && (l = wr[n]))
        return l;
      if (n === "hasOwnProperty")
        return Sr;
    }
    const o = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      L(t) ? t : r
    );
    return (ze(n) ? mn.has(n) : Er(n)) || (s || K(t, "get", n), i) ? o : L(o) ? c && Ct(n) ? o : o.value : Y(o) ? s ? gt(o) : bn(o) : o;
  }
}
class Nr extends _n {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, r, s) {
    let i = t[n];
    if (!this._isShallow) {
      const l = ie(i);
      if (!z(r) && !ie(r) && (i = E(i), r = E(r)), !M(t) && L(i) && !L(r))
        return l ? !1 : (i.value = r, !0);
    }
    const c = M(t) && Ct(n) ? Number(n) < t.length : Dt(t, n), o = Reflect.set(
      t,
      n,
      r,
      L(t) ? t : s
    );
    return t === E(s) && (c ? ue(r, i) && ae(t, "set", n, r, i) : ae(t, "add", n, r)), o;
  }
  deleteProperty(t, n) {
    const r = Dt(t, n), s = t[n], i = Reflect.deleteProperty(t, n);
    return i && r && ae(t, "delete", n, void 0, s), i;
  }
  has(t, n) {
    const r = Reflect.has(t, n);
    return (!ze(n) || !mn.has(n)) && K(t, "has", n), r;
  }
  ownKeys(t) {
    return K(
      t,
      "iterate",
      M(t) ? "length" : me
    ), Reflect.ownKeys(t);
  }
}
class Dr extends _n {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && se(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && se(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const Or = /* @__PURE__ */ new Nr(), Tr = /* @__PURE__ */ new Dr(), $t = (e) => e, qe = (e) => Reflect.getPrototypeOf(e);
function $r(e, t, n) {
  return function(...r) {
    const s = this.__v_raw, i = E(s), c = Ne(i), o = e === "entries" || e === Symbol.iterator && c, l = e === "keys" && c, p = s[e](...r), _ = n ? $t : t ? xt : H;
    return !t && K(
      i,
      "iterate",
      l ? Tt : me
    ), {
      // iterator protocol
      next() {
        const { value: a, done: g } = p.next();
        return g ? { value: a, done: g } : {
          value: o ? [_(a[0]), _(a[1])] : _(a),
          done: g
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Be(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      se(
        `${an(e)} operation ${n}failed: target is readonly.`,
        E(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function xr(e, t) {
  const n = {
    get(s) {
      const i = this.__v_raw, c = E(i), o = E(s);
      e || (ue(s, o) && K(c, "get", s), K(c, "get", o));
      const { has: l } = qe(c), p = t ? $t : e ? xt : H;
      if (l.call(c, s))
        return p(i.get(s));
      if (l.call(c, o))
        return p(i.get(o));
      i !== c && i.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !e && K(E(s), "iterate", me), Reflect.get(s, "size", s);
    },
    has(s) {
      const i = this.__v_raw, c = E(i), o = E(s);
      return e || (ue(s, o) && K(c, "has", s), K(c, "has", o)), s === o ? i.has(s) : i.has(s) || i.has(o);
    },
    forEach(s, i) {
      const c = this, o = c.__v_raw, l = E(o), p = t ? $t : e ? xt : H;
      return !e && K(l, "iterate", me), o.forEach((_, a) => s.call(i, p(_), p(a), c));
    }
  };
  return fe(
    n,
    e ? {
      add: Be("add"),
      set: Be("set"),
      delete: Be("delete"),
      clear: Be("clear")
    } : {
      add(s) {
        !t && !z(s) && !ie(s) && (s = E(s));
        const i = E(this);
        return qe(i).has.call(i, s) || (i.add(s), ae(i, "add", s, s)), this;
      },
      set(s, i) {
        !t && !z(i) && !ie(i) && (i = E(i));
        const c = E(this), { has: o, get: l } = qe(c);
        let p = o.call(c, s);
        p ? process.env.NODE_ENV !== "production" && Qt(c, o, s) : (s = E(s), p = o.call(c, s));
        const _ = l.call(c, s);
        return c.set(s, i), p ? ue(i, _) && ae(c, "set", s, i, _) : ae(c, "add", s, i), this;
      },
      delete(s) {
        const i = E(this), { has: c, get: o } = qe(i);
        let l = c.call(i, s);
        l ? process.env.NODE_ENV !== "production" && Qt(i, c, s) : (s = E(s), l = c.call(i, s));
        const p = o ? o.call(i, s) : void 0, _ = i.delete(s);
        return l && ae(i, "delete", s, void 0, p), _;
      },
      clear() {
        const s = E(this), i = s.size !== 0, c = process.env.NODE_ENV !== "production" ? Ne(s) ? new Map(s) : new Set(s) : void 0, o = s.clear();
        return i && ae(
          s,
          "clear",
          void 0,
          void 0,
          c
        ), o;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    n[s] = $r(s, e, t);
  }), n;
}
function vn(e, t) {
  const n = xr(e, t);
  return (r, s, i) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? r : Reflect.get(
    Dt(n, s) && s in r ? n : r,
    s,
    i
  );
}
const Mr = {
  get: /* @__PURE__ */ vn(!1, !1)
}, Rr = {
  get: /* @__PURE__ */ vn(!0, !1)
};
function Qt(e, t, n) {
  const r = E(n);
  if (r !== n && t.call(e, r)) {
    const s = on(e);
    se(
      `Reactive ${s} contains both the raw and reactive versions of the same object${s === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const yn = /* @__PURE__ */ new WeakMap(), Vr = /* @__PURE__ */ new WeakMap(), wn = /* @__PURE__ */ new WeakMap(), Ir = /* @__PURE__ */ new WeakMap();
function Cr(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Ar(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Cr(on(e));
}
function bn(e) {
  return ie(e) ? e : En(
    e,
    !1,
    Or,
    Mr,
    yn
  );
}
function gt(e) {
  return En(
    e,
    !0,
    Tr,
    Rr,
    wn
  );
}
function En(e, t, n, r, s) {
  if (!Y(e))
    return process.env.NODE_ENV !== "production" && se(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = Ar(e);
  if (i === 0)
    return e;
  const c = s.get(e);
  if (c)
    return c;
  const o = new Proxy(
    e,
    i === 2 ? r : n
  );
  return s.set(e, o), o;
}
function Le(e) {
  return ie(e) ? Le(e.__v_raw) : !!(e && e.__v_isReactive);
}
function ie(e) {
  return !!(e && e.__v_isReadonly);
}
function z(e) {
  return !!(e && e.__v_isShallow);
}
function st(e) {
  return e ? !!e.__v_raw : !1;
}
function E(e) {
  const t = e && e.__v_raw;
  return t ? E(t) : e;
}
const H = (e) => Y(e) ? bn(e) : e, xt = (e) => Y(e) ? gt(e) : e;
function L(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function Ht(e) {
  return Sn(e, !1);
}
function jr(e) {
  return Sn(e, !0);
}
function Sn(e, t) {
  return L(e) ? e : new kr(e, t);
}
class kr {
  constructor(t, n) {
    this.dep = new ht(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : E(t), this._value = n ? t : H(t), this.__v_isShallow = n;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, r = this.__v_isShallow || z(t) || ie(t);
    t = r ? t : E(t), ue(t, n) && (this._rawValue = t, this._value = r ? t : H(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: n
    }) : this.dep.trigger());
  }
}
function Nn(e) {
  return L(e) ? e.value : e;
}
function _e(e) {
  return A(e) ? e() : Nn(e);
}
class Lr {
  constructor(t) {
    this.__v_isRef = !0, this._value = void 0;
    const n = this.dep = new ht(), { get: r, set: s } = t(n.track.bind(n), n.trigger.bind(n));
    this._get = r, this._set = s;
  }
  get value() {
    return this._value = this._get();
  }
  set value(t) {
    this._set(t);
  }
}
function Fr(e) {
  return new Lr(e);
}
class Pr {
  constructor(t, n, r) {
    this._object = t, this._key = n, this._defaultValue = r, this.__v_isRef = !0, this._value = void 0;
  }
  get value() {
    const t = this._object[this._key];
    return this._value = t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return yr(E(this._object), this._key);
  }
}
class Hr {
  constructor(t) {
    this._getter = t, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
  }
  get value() {
    return this._value = this._getter();
  }
}
function Wr(e, t, n) {
  return L(e) ? e : A(e) ? new Hr(e) : Y(e) && arguments.length > 1 ? Kr(e, t, n) : Ht(e);
}
function Kr(e, t, n) {
  const r = e[t];
  return L(r) ? r : new Pr(e, t, n);
}
class Yr {
  constructor(t, n, r) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new ht(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Pe - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = r;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    D !== this)
      return un(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return pn(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && se("Write operation failed: computed value is readonly");
  }
}
function zr(e, t, n = !1) {
  let r, s;
  A(e) ? r = e : (r = e.get, s = e.set);
  const i = new Yr(r, s, n);
  return process.env.NODE_ENV, i;
}
const Ge = {}, it = /* @__PURE__ */ new WeakMap();
let ge;
function Ur(e, t = !1, n = ge) {
  if (n) {
    let r = it.get(n);
    r || it.set(n, r = []), r.push(e);
  } else process.env.NODE_ENV !== "production" && !t && se(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function Jr(e, t, n = Fe) {
  const { immediate: r, deep: s, once: i, scheduler: c, augmentJob: o, call: l } = n, p = (b) => {
    (n.onWarn || se)(
      "Invalid watch source: ",
      b,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, _ = (b) => s ? b : z(b) || s === !1 || s === 0 ? le(b, 1) : le(b);
  let a, g, m, S, O = !1, V = !1;
  if (L(e) ? (g = () => e.value, O = z(e)) : Le(e) ? (g = () => _(e), O = !0) : M(e) ? (V = !0, O = e.some((b) => Le(b) || z(b)), g = () => e.map((b) => {
    if (L(b))
      return b.value;
    if (Le(b))
      return _(b);
    if (A(b))
      return l ? l(b, 2) : b();
    process.env.NODE_ENV !== "production" && p(b);
  })) : A(e) ? t ? g = l ? () => l(e, 2) : e : g = () => {
    if (m) {
      Te();
      try {
        m();
      } finally {
        $e();
      }
    }
    const b = ge;
    ge = a;
    try {
      return l ? l(e, 3, [S]) : e(S);
    } finally {
      ge = b;
    }
  } : (g = Se, process.env.NODE_ENV !== "production" && p(e)), t && s) {
    const b = g, R = s === !0 ? 1 / 0 : s;
    g = () => le(b(), R);
  }
  const I = () => {
    a.stop();
  };
  if (i && t) {
    const b = t;
    t = (...R) => {
      b(...R), I();
    };
  }
  let U = V ? new Array(e.length).fill(Ge) : Ge;
  const F = (b) => {
    if (!(!(a.flags & 1) || !a.dirty && !b))
      if (t) {
        const R = a.run();
        if (s || O || (V ? R.some((P, Z) => ue(P, U[Z])) : ue(R, U))) {
          m && m();
          const P = ge;
          ge = a;
          try {
            const Z = [
              R,
              // pass undefined as the old value when it's changed for the first time
              U === Ge ? void 0 : V && U[0] === Ge ? [] : U,
              S
            ];
            U = R, l ? l(t, 3, Z) : (
              // @ts-expect-error
              t(...Z)
            );
          } finally {
            ge = P;
          }
        }
      } else
        a.run();
  };
  return o && o(F), a = new mr(g), a.scheduler = c ? () => c(F, !1) : F, S = (b) => Ur(b, !1, a), m = a.onStop = () => {
    const b = it.get(a);
    if (b) {
      if (l)
        l(b, 4);
      else
        for (const R of b) R();
      it.delete(a);
    }
  }, process.env.NODE_ENV !== "production" && (a.onTrack = n.onTrack, a.onTrigger = n.onTrigger), t ? r ? F(!0) : U = a.run() : c ? c(F.bind(null, !0), !0) : a.run(), I.pause = a.pause.bind(a), I.resume = a.resume.bind(a), I.stop = I, I;
}
function le(e, t = 1 / 0, n) {
  if (t <= 0 || !Y(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, L(e))
    le(e.value, t, n);
  else if (M(e))
    for (let r = 0; r < e.length; r++)
      le(e[r], t, n);
  else if (cr(e) || Ne(e))
    e.forEach((r) => {
      le(r, t, n);
    });
  else if (ur(e)) {
    for (const r in e)
      le(e[r], t, n);
    for (const r of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, r) && le(e[r], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const ve = [];
function qr(e) {
  ve.push(e);
}
function Br() {
  ve.pop();
}
let wt = !1;
function k(e, ...t) {
  if (wt) return;
  wt = !0, Te();
  const n = ve.length ? ve[ve.length - 1].component : null, r = n && n.appContext.config.warnHandler, s = Gr();
  if (r)
    mt(
      r,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((i) => {
          var c, o;
          return (o = (c = i.toString) == null ? void 0 : c.call(i)) != null ? o : JSON.stringify(i);
        }).join(""),
        n && n.proxy,
        s.map(
          ({ vnode: i }) => `at <${Hn(n, i.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    s.length && i.push(`
`, ...Qr(s)), console.warn(...i);
  }
  $e(), wt = !1;
}
function Gr() {
  let e = ve[ve.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const r = e.component && e.component.parent;
    e = r && r.vnode;
  }
  return t;
}
function Qr(e) {
  const t = [];
  return e.forEach((n, r) => {
    t.push(...r === 0 ? [] : [`
`], ...Zr(n));
  }), t;
}
function Zr({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, s = ` at <${Hn(
    e.component,
    e.type,
    r
  )}`, i = ">" + n;
  return e.props ? [s, ...Xr(e.props), i] : [s + i];
}
function Xr(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((r) => {
    t.push(...Dn(r, e[r]));
  }), n.length > 3 && t.push(" ..."), t;
}
function Dn(e, t, n) {
  return re(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : L(t) ? (t = Dn(e, E(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : A(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = E(t), n ? t : [`${e}=`, t]);
}
const Wt = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function mt(e, t, n, r) {
  try {
    return r ? e(...r) : e();
  } catch (s) {
    Yt(s, t, n);
  }
}
function Kt(e, t, n, r) {
  if (A(e)) {
    const s = mt(e, t, n, r);
    return s && ar(s) && s.catch((i) => {
      Yt(i, t, n);
    }), s;
  }
  if (M(e)) {
    const s = [];
    for (let i = 0; i < e.length; i++)
      s.push(Kt(e[i], t, n, r));
    return s;
  } else process.env.NODE_ENV !== "production" && k(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function Yt(e, t, n, r = !0) {
  const s = t ? t.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: c } = t && t.appContext.config || Fe;
  if (t) {
    let o = t.parent;
    const l = t.proxy, p = process.env.NODE_ENV !== "production" ? Wt[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; o; ) {
      const _ = o.ec;
      if (_) {
        for (let a = 0; a < _.length; a++)
          if (_[a](e, l, p) === !1)
            return;
      }
      o = o.parent;
    }
    if (i) {
      Te(), mt(i, null, 10, [
        e,
        l,
        p
      ]), $e();
      return;
    }
  }
  es(e, n, s, r, c);
}
function es(e, t, n, r = !0, s = !1) {
  if (process.env.NODE_ENV !== "production") {
    const i = Wt[t];
    if (n && qr(n), k(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Br(), r)
      throw e;
    console.error(e);
  } else {
    if (s)
      throw e;
    console.error(e);
  }
}
const q = [];
let ee = -1;
const De = [];
let ce = null, be = 0;
const On = /* @__PURE__ */ Promise.resolve();
let ot = null;
const ts = 100;
function Tn(e) {
  const t = ot || On;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function ns(e) {
  let t = ee + 1, n = q.length;
  for (; t < n; ) {
    const r = t + n >>> 1, s = q[r], i = We(s);
    i < e || i === e && s.flags & 2 ? t = r + 1 : n = r;
  }
  return t;
}
function $n(e) {
  if (!(e.flags & 1)) {
    const t = We(e), n = q[q.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= We(n) ? q.push(e) : q.splice(ns(t), 0, e), e.flags |= 1, xn();
  }
}
function xn() {
  ot || (ot = On.then(Rn));
}
function Mn(e) {
  M(e) ? De.push(...e) : ce && e.id === -1 ? ce.splice(be + 1, 0, e) : e.flags & 1 || (De.push(e), e.flags |= 1), xn();
}
function rs(e) {
  if (De.length) {
    const t = [...new Set(De)].sort(
      (n, r) => We(n) - We(r)
    );
    if (De.length = 0, ce) {
      ce.push(...t);
      return;
    }
    for (ce = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), be = 0; be < ce.length; be++) {
      const n = ce[be];
      process.env.NODE_ENV !== "production" && Vn(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    ce = null, be = 0;
  }
}
const We = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Rn(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => Vn(e, n) : Se;
  try {
    for (ee = 0; ee < q.length; ee++) {
      const n = q[ee];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), mt(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; ee < q.length; ee++) {
      const n = q[ee];
      n && (n.flags &= -2);
    }
    ee = -1, q.length = 0, rs(e), ot = null, (q.length || De.length) && Rn(e);
  }
}
function Vn(e, t) {
  const n = e.get(t) || 0;
  if (n > ts) {
    const r = t.i, s = r && Pn(r.type);
    return Yt(
      `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
const bt = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (pt().__VUE_HMR_RUNTIME__ = {
  createRecord: Et(ss),
  rerender: Et(is),
  reload: Et(os)
});
const ct = /* @__PURE__ */ new Map();
function ss(e, t) {
  return ct.has(e) ? !1 : (ct.set(e, {
    initialDef: at(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function at(e) {
  return Wn(e) ? e.__vccOpts : e;
}
function is(e, t) {
  const n = ct.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((r) => {
    t && (r.render = t, at(r.type).render = t), r.renderCache = [], r.update();
  }));
}
function os(e, t) {
  const n = ct.get(e);
  if (!n) return;
  t = at(t), Zt(n.initialDef, t);
  const r = [...n.instances];
  for (let s = 0; s < r.length; s++) {
    const i = r[s], c = at(i.type);
    let o = bt.get(c);
    o || (c !== n.initialDef && Zt(c, t), bt.set(c, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? $n(() => {
      i.parent.update(), o.delete(i);
    }) : i.appContext.reload ? i.appContext.reload() : typeof window != "undefined" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(c);
  }
  Mn(() => {
    bt.clear();
  });
}
function Zt(e, t) {
  fe(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function Et(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (r) {
      console.error(r), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let Ee, Qe = [];
function In(e, t) {
  var n, r;
  Ee = e, Ee ? (Ee.enabled = !0, Qe.forEach(({ event: s, args: i }) => Ee.emit(s, ...i)), Qe = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window != "undefined" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((r = (n = window.navigator) == null ? void 0 : n.userAgent) != null && r.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
    In(i, t);
  }), setTimeout(() => {
    Ee || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Qe = []);
  }, 3e3)) : Qe = [];
}
let Ke = null, cs = null;
const as = (e) => e.__isTeleport;
function Cn(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, Cn(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
pt().requestIdleCallback;
pt().cancelIdleCallback;
function ls(e, t, n = xe, r = !1) {
  if (n) {
    const s = n[e] || (n[e] = []), i = t.__weh || (t.__weh = (...c) => {
      Te();
      const o = Vs(n), l = Kt(t, n, e, c);
      return o(), $e(), l;
    });
    return r ? s.unshift(i) : s.push(i), i;
  } else if (process.env.NODE_ENV !== "production") {
    const s = fr(Wt[e].replace(/ hook$/, ""));
    k(
      `${s} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const us = (e) => (t, n = xe) => {
  (!Ye || e === "sp") && ls(e, (...r) => t(...r), n);
}, fs = us("m"), ds = Symbol.for("v-ndc"), ps = {};
process.env.NODE_ENV !== "production" && (ps.ownKeys = (e) => (k(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
let hs = null;
function gs(e, t, n = !1) {
  const r = Jt();
  if (r || hs) {
    let s = r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return n && A(t) ? t.call(r && r.proxy) : t;
    process.env.NODE_ENV !== "production" && k(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && k("inject() can only be used inside setup() or functional components.");
}
const ms = {}, An = (e) => Object.getPrototypeOf(e) === ms, _s = Es, vs = Symbol.for("v-scx"), ys = () => {
  {
    const e = gs(vs);
    return e || process.env.NODE_ENV !== "production" && k(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function zt(e, t, n) {
  return process.env.NODE_ENV !== "production" && !A(t) && k(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), ws(e, t, n);
}
function ws(e, t, n = Fe) {
  const { immediate: r, deep: s, flush: i, once: c } = n;
  process.env.NODE_ENV !== "production" && !t && (r !== void 0 && k(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), s !== void 0 && k(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), c !== void 0 && k(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const o = fe({}, n);
  process.env.NODE_ENV !== "production" && (o.onWarn = k);
  const l = t && r || !t && i !== "post";
  let p;
  if (Ye) {
    if (i === "sync") {
      const m = ys();
      p = m.__watcherHandles || (m.__watcherHandles = []);
    } else if (!l) {
      const m = () => {
      };
      return m.stop = Se, m.resume = Se, m.pause = Se, m;
    }
  }
  const _ = xe;
  o.call = (m, S, O) => Kt(m, _, S, O);
  let a = !1;
  i === "post" ? o.scheduler = (m) => {
    _s(m, _ && _.suspense);
  } : i !== "sync" && (a = !0, o.scheduler = (m, S) => {
    S ? m() : $n(m);
  }), o.augmentJob = (m) => {
    t && (m.flags |= 4), a && (m.flags |= 2, _ && (m.id = _.uid, m.i = _));
  };
  const g = Jr(e, t, o);
  return Ye && (p ? p.push(g) : l && g()), g;
}
const bs = (e) => e.__isSuspense;
function Es(e, t) {
  t && t.pendingBranch ? M(e) ? t.effects.push(...e) : t.effects.push(e) : Mn(e);
}
const jn = Symbol.for("v-fgt"), Ss = Symbol.for("v-txt"), Ns = Symbol.for("v-cmt");
function Ds(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
const Os = (...e) => Ln(
  ...e
), kn = ({ key: e }) => e != null ? e : null, et = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? re(e) || L(e) || A(e) ? { i: Ke, r: e, k: t, f: !!n } : e : null);
function Ts(e, t = null, n = null, r = 0, s = null, i = e === jn ? 0 : 1, c = !1, o = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && kn(t),
    ref: t && et(t),
    scopeId: cs,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: r,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: Ke
  };
  return o ? (Ut(l, n), i & 128 && e.normalize(l)) : n && (l.shapeFlag |= re(n) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && k("VNode created with invalid key (NaN). VNode type:", l.type), l;
}
const $s = process.env.NODE_ENV !== "production" ? Os : Ln;
function Ln(e, t = null, n = null, r = 0, s = null, i = !1) {
  if ((!e || e === ds) && (process.env.NODE_ENV !== "production" && !e && k(`Invalid vnode type when creating vnode: ${e}.`), e = Ns), Ds(e)) {
    const o = lt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && Ut(o, n), o.patchFlag = -2, o;
  }
  if (Wn(e) && (e = e.__vccOpts), t) {
    t = xs(t);
    let { class: o, style: l } = t;
    o && !re(o) && (t.class = jt(o)), Y(l) && (st(l) && !M(l) && (l = fe({}, l)), t.style = At(l));
  }
  const c = re(e) ? 1 : bs(e) ? 128 : as(e) ? 64 : Y(e) ? 4 : A(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && c & 4 && st(e) && (e = E(e), k(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), Ts(
    e,
    t,
    n,
    r,
    s,
    c,
    i,
    !0
  );
}
function xs(e) {
  return e ? st(e) || An(e) ? fe({}, e) : e : null;
}
function lt(e, t, n = !1, r = !1) {
  const { props: s, ref: i, patchFlag: c, children: o, transition: l } = e, p = t ? Rs(s || {}, t) : s, _ = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: p,
    key: p && kn(p),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && i ? M(i) ? i.concat(et(t)) : [i, et(t)] : et(t)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && c === -1 && M(o) ? o.map(Fn) : o,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== jn ? c === -1 ? 16 : c | 16 : c,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && lt(e.ssContent),
    ssFallback: e.ssFallback && lt(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && r && Cn(
    _,
    l.clone(_)
  ), _;
}
function Fn(e) {
  const t = lt(e);
  return M(e.children) && (t.children = e.children.map(Fn)), t;
}
function Ms(e = " ", t = 0) {
  return $s(Ss, null, e, t);
}
function Ut(e, t) {
  let n = 0;
  const { shapeFlag: r } = e;
  if (t == null)
    t = null;
  else if (M(t))
    n = 16;
  else if (typeof t == "object")
    if (r & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), Ut(e, s()), s._c && (s._d = !0));
      return;
    } else
      n = 32, !t._ && !An(t) && (t._ctx = Ke);
  else A(t) ? (t = { default: t, _ctx: Ke }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [Ms(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Rs(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (const s in r)
      if (s === "class")
        t.class !== r.class && (t.class = jt([t.class, r.class]));
      else if (s === "style")
        t.style = At([t.style, r.style]);
      else if (ir(s)) {
        const i = t[s], c = r[s];
        c && i !== c && !(M(i) && i.includes(c)) && (t[s] = i ? [].concat(i, c) : c);
      } else s !== "" && (t[s] = r[s]);
  }
  return t;
}
let xe = null;
const Jt = () => xe || Ke;
let Mt;
{
  const e = pt(), t = (n, r) => {
    let s;
    return (s = e[n]) || (s = e[n] = []), s.push(r), (i) => {
      s.length > 1 ? s.forEach((c) => c(i)) : s[0](i);
    };
  };
  Mt = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => xe = n
  ), t(
    "__VUE_SSR_SETTERS__",
    (n) => Ye = n
  );
}
const Vs = (e) => {
  const t = xe;
  return Mt(e), e.scope.on(), () => {
    e.scope.off(), Mt(t);
  };
};
let Ye = !1;
process.env.NODE_ENV;
const Is = /(?:^|[-_])(\w)/g, Cs = (e) => e.replace(Is, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Pn(e, t = !0) {
  return A(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Hn(e, t, n = !1) {
  let r = Pn(t);
  if (!r && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (r = s[1]);
  }
  if (!r && e && e.parent) {
    const s = (i) => {
      for (const c in i)
        if (i[c] === t)
          return c;
    };
    r = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return r ? Cs(r) : n ? "App" : "Anonymous";
}
function Wn(e) {
  return A(e) && "__vccOpts" in e;
}
const Kn = (e, t) => {
  const n = zr(e, t, Ye);
  if (process.env.NODE_ENV !== "production") {
    const r = Jt();
    r && r.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function As() {
  if (process.env.NODE_ENV === "production" || typeof window == "undefined")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, s = {
    __vue_custom_formatter: !0,
    header(a) {
      if (!Y(a))
        return null;
      if (a.__isVue)
        return ["div", e, "VueInstance"];
      if (L(a)) {
        Te();
        const g = a.value;
        return $e(), [
          "div",
          {},
          ["span", e, _(a)],
          "<",
          o(g),
          ">"
        ];
      } else {
        if (Le(a))
          return [
            "div",
            {},
            ["span", e, z(a) ? "ShallowReactive" : "Reactive"],
            "<",
            o(a),
            `>${ie(a) ? " (readonly)" : ""}`
          ];
        if (ie(a))
          return [
            "div",
            {},
            ["span", e, z(a) ? "ShallowReadonly" : "Readonly"],
            "<",
            o(a),
            ">"
          ];
      }
      return null;
    },
    hasBody(a) {
      return a && a.__isVue;
    },
    body(a) {
      if (a && a.__isVue)
        return [
          "div",
          {},
          ...i(a.$)
        ];
    }
  };
  function i(a) {
    const g = [];
    a.type.props && a.props && g.push(c("props", E(a.props))), a.setupState !== Fe && g.push(c("setup", a.setupState)), a.data !== Fe && g.push(c("data", E(a.data)));
    const m = l(a, "computed");
    m && g.push(c("computed", m));
    const S = l(a, "inject");
    return S && g.push(c("injected", S)), g.push([
      "div",
      {},
      [
        "span",
        {
          style: r.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: a }]
    ]), g;
  }
  function c(a, g) {
    return g = fe({}, g), Object.keys(g).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        a
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(g).map((m) => [
          "div",
          {},
          ["span", r, m + ": "],
          o(g[m], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function o(a, g = !0) {
    return typeof a == "number" ? ["span", t, a] : typeof a == "string" ? ["span", n, JSON.stringify(a)] : typeof a == "boolean" ? ["span", r, a] : Y(a) ? ["object", { object: g ? E(a) : a }] : ["span", n, String(a)];
  }
  function l(a, g) {
    const m = a.type;
    if (A(m))
      return;
    const S = {};
    for (const O in a.ctx)
      p(m, O, g) && (S[O] = a.ctx[O]);
    return S;
  }
  function p(a, g, m) {
    const S = a[m];
    if (M(S) && S.includes(g) || Y(S) && g in S || a.extends && p(a.extends, g, m) || a.mixins && a.mixins.some((O) => p(O, g, m)))
      return !0;
  }
  function _(a) {
    return z(a) ? "ShallowRef" : a.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function js() {
  As();
}
process.env.NODE_ENV !== "production" && js();
const ks = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const Ls = Object.prototype.toString, Fs = (e) => Ls.call(e) === "[object Object]", Rt = () => {
};
function Ps(...e) {
  if (e.length !== 1)
    return Wr(...e);
  const t = e[0];
  return typeof t == "function" ? gt(Fr(() => ({ get: t, set: Rt }))) : Ht(t);
}
function Yn(e, t) {
  function n(...r) {
    return new Promise((s, i) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(s).catch(i);
    });
  }
  return n;
}
const zn = (e) => e();
function Hs(...e) {
  let t = 0, n, r = !0, s = Rt, i, c, o, l, p;
  !L(e[0]) && typeof e[0] == "object" ? { delay: c, trailing: o = !0, leading: l = !0, rejectOnCancel: p = !1 } = e[0] : [c, o = !0, l = !0, p = !1] = e;
  const _ = () => {
    n && (clearTimeout(n), n = void 0, s(), s = Rt);
  };
  return (g) => {
    const m = _e(c), S = Date.now() - t, O = () => i = g();
    return _(), m <= 0 ? (t = Date.now(), O()) : (S > m && (l || !r) ? (t = Date.now(), O()) : o && (i = new Promise((V, I) => {
      s = p ? I : V, n = setTimeout(() => {
        t = Date.now(), r = !0, V(O()), _();
      }, Math.max(0, m - S));
    })), !l && !n && (n = setTimeout(() => r = !0, m)), r = !1, i);
  };
}
function Ws(e = zn, t = {}) {
  const {
    initialState: n = "active"
  } = t, r = Ps(n === "active");
  function s() {
    r.value = !1;
  }
  function i() {
    r.value = !0;
  }
  const c = (...o) => {
    r.value && e(...o);
  };
  return { isActive: gt(r), pause: s, resume: i, eventFilter: c };
}
function St(e) {
  return Array.isArray(e) ? e : [e];
}
function Ks(e) {
  return Jt();
}
// @__NO_SIDE_EFFECTS__
function Ys(e, t = 200, n = !1, r = !0, s = !1) {
  return Yn(
    Hs(t, n, r, s),
    e
  );
}
function zs(e, t, n = {}) {
  const {
    eventFilter: r = zn,
    ...s
  } = n;
  return zt(
    e,
    Yn(
      r,
      t
    ),
    s
  );
}
function Us(e, t, n = {}) {
  const {
    eventFilter: r,
    initialState: s = "active",
    ...i
  } = n, { eventFilter: c, pause: o, resume: l, isActive: p } = Ws(r, { initialState: s });
  return { stop: zs(
    e,
    t,
    {
      ...i,
      eventFilter: c
    }
  ), pause: o, resume: l, isActive: p };
}
function Js(e, t = !0, n) {
  Ks() ? fs(e, n) : t ? e() : Tn(e);
}
function qs(e, t, n) {
  return zt(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const ut = ks ? window : void 0;
function Bs(e) {
  var t;
  const n = _e(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function Xt(...e) {
  const t = [], n = () => {
    t.forEach((o) => o()), t.length = 0;
  }, r = (o, l, p, _) => (o.addEventListener(l, p, _), () => o.removeEventListener(l, p, _)), s = Kn(() => {
    const o = St(_e(e[0])).filter((l) => l != null);
    return o.every((l) => typeof l != "string") ? o : void 0;
  }), i = qs(
    () => {
      var o, l;
      return [
        (l = (o = s.value) == null ? void 0 : o.map((p) => Bs(p))) != null ? l : [ut].filter((p) => p != null),
        St(_e(s.value ? e[1] : e[0])),
        St(Nn(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        _e(s.value ? e[3] : e[2])
      ];
    },
    ([o, l, p, _]) => {
      if (n(), !(o != null && o.length) || !(l != null && l.length) || !(p != null && p.length))
        return;
      const a = Fs(_) ? { ..._ } : _;
      t.push(
        ...o.flatMap(
          (g) => l.flatMap(
            (m) => p.map((S) => r(g, m, S, a))
          )
        )
      );
    },
    { flush: "post" }
  );
  return () => {
    i(), n();
  };
}
const Ze = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, Xe = "__vueuse_ssr_handlers__", Gs = /* @__PURE__ */ Qs();
function Qs() {
  return Xe in Ze || (Ze[Xe] = Ze[Xe] || {}), Ze[Xe];
}
function Zs(e, t) {
  return Gs[e] || t;
}
function Xs(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const ei = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, en = "vueuse-storage";
function ti(e, t, n, r = {}) {
  var s;
  const {
    flush: i = "pre",
    deep: c = !0,
    listenToStorageChanges: o = !0,
    writeDefaults: l = !0,
    mergeDefaults: p = !1,
    shallow: _,
    window: a = ut,
    eventFilter: g,
    onError: m = (d) => {
      console.error(d);
    },
    initOnMounted: S
  } = r, O = (_ ? jr : Ht)(typeof t == "function" ? t() : t), V = Kn(() => _e(e));
  if (!n)
    try {
      n = Zs("getDefaultStorage", () => {
        var d;
        return (d = ut) == null ? void 0 : d.localStorage;
      })();
    } catch (d) {
      m(d);
    }
  if (!n)
    return O;
  const I = _e(t), U = Xs(I), F = (s = r.serializer) != null ? s : ei[U], { pause: b, resume: R } = Us(
    O,
    () => x(O.value),
    { flush: i, deep: c, eventFilter: g }
  );
  zt(V, () => Q(), { flush: i });
  let P = !1;
  const Z = (d) => {
    S && !P || Q(d);
  }, Me = (d) => {
    S && !P || Ue(d);
  };
  a && o && (n instanceof Storage ? Xt(a, "storage", Z, { passive: !0 }) : Xt(a, en, Me)), S ? Js(() => {
    P = !0, Q();
  }) : Q();
  function de(d, f) {
    if (a) {
      const u = {
        key: V.value,
        oldValue: d,
        newValue: f,
        storageArea: n
      };
      a.dispatchEvent(n instanceof Storage ? new StorageEvent("storage", u) : new CustomEvent(en, {
        detail: u
      }));
    }
  }
  function x(d) {
    try {
      const f = n.getItem(V.value);
      if (d == null)
        de(f, null), n.removeItem(V.value);
      else {
        const u = F.write(d);
        f !== u && (n.setItem(V.value, u), de(f, u));
      }
    } catch (f) {
      m(f);
    }
  }
  function N(d) {
    const f = d ? d.newValue : n.getItem(V.value);
    if (f == null)
      return l && I != null && n.setItem(V.value, F.write(I)), I;
    if (!d && p) {
      const u = F.read(f);
      return typeof p == "function" ? p(u, I) : U === "object" && !Array.isArray(u) ? { ...I, ...u } : u;
    } else return typeof f != "string" ? f : F.read(f);
  }
  function Q(d) {
    if (!(d && d.storageArea !== n)) {
      if (d && d.key == null) {
        O.value = I;
        return;
      }
      if (!(d && d.key !== V.value)) {
        b();
        try {
          (d == null ? void 0 : d.newValue) !== F.write(O.value) && (O.value = N(d));
        } catch (f) {
          m(f);
        } finally {
          d ? Tn(R) : R();
        }
      }
    }
  }
  function Ue(d) {
    Q(d.detail);
  }
  return O;
}
function ni(e, t, n = {}) {
  const { window: r = ut } = n;
  return ti(e, t, r == null ? void 0 : r.localStorage, n);
}
const ri = [
  ".ant-pagination-item",
  ".ant-pagination-prev",
  ".ant-pagination-next",
  ".ant-pagination-jump-prev",
  ".ant-pagination-jump-next"
], si = ["[data-tracing]", ".ant-btn", ".link"], ii = {
  "phone-outlined": "拨打电话",
  "ant-design:copy-outlined": "复制",
  "ant-design:picture-outlined": "上传图片",
  "ant-design:eye-outlined": "查看图片",
  "ant-design:delete-outlined": "删除图片",
  "ant-design:search-outlined": "搜索",
  "ant-design:caret-right-outlined": "播放",
  "ant-design:pause-outlined": "暂停",
  "ant-design:sound-filled": "静音",
  "material-symbols:no-sound": "取消静音",
  "ant-design:reload-outlined": "刷新",
  "ant-design:sound-outlined": "播放/暂停",
  sms: "发送短信",
  parts: "配件",
  collect: "查看收藏",
  msg: "查看消息",
  exportTask: "下载",
  help: "钉钉帮助",
  location: "定位",
  copy: "复制",
  completePic: "完成照片",
  QQ: "QQ"
}, oi = (e) => ii[e] || "", Vt = (e) => {
  const t = e.closest(si.join(","));
  if (t && !t.dataset.tracingDisabled) {
    if (t.tagName === "svg" && t.parentElement)
      return Vt(t.parentElement) || oi(t.dataset.tracing);
    let r = "";
    const s = t.childNodes;
    return t.dataset.tracing ? r = t.dataset.tracing : s.length > 1 && Bn(s[0], "Text") && s[0].nodeValue ? r = s[0].nodeValue : r = t.title || t.innerText, !r && t.parentElement ? Vt(t.parentElement) : /^\d{12}$/.test(r) ? "工单详情" : /^OCN\d{13}$/.test(r) ? "投诉单详情" : /^DZB\d{13}$/.test(r) ? "质保单详情" : r;
  }
  return e.closest(ri.join(",")) ? "翻页" : "";
};
window.addEventListener(
  "click",
  (e) => {
    try {
      const t = e.target, n = Vt(t);
      let r = "";
      try {
        r = t.closest("tr").querySelector(".order-no").innerText.split(`
`)[0];
      } catch {
      }
      if (!r)
        try {
          r = t.closest(".order-detail").querySelector(".order-no").innerText.split(`
`)[0];
        } catch {
        }
      return n && hi(n, r);
    } catch (t) {
      throw `getButtonName error: ${t}`;
    }
  },
  !0
);
const ne = {
  preEventTime: 0,
  //上次事件时间
  blurTime: 0,
  // 失去焦点时长 单位 ms
  inactivityFlag: !1
  // 是否挂机 大于15分钟
}, ci = (e) => {
  ne.preEventTime = e, ne.blurTime = 0, ne.inactivityFlag = !1;
}, ai = (e) => ne.preEventTime ? ((e - ne.preEventTime - ne.blurTime) / 1e3).toFixed(1) : "0";
let Un = 0;
window.addEventListener("blur", () => {
  Un = +/* @__PURE__ */ new Date();
});
window.addEventListener("focus", () => {
  ne.blurTime += +/* @__PURE__ */ new Date() - Un;
});
let tn = +/* @__PURE__ */ new Date();
window.addEventListener(
  "click",
  /* @__PURE__ */ Ys(() => {
    const e = +/* @__PURE__ */ new Date();
    e - tn > 900 * 1e3 && (ne.inactivityFlag = !0), tn = e;
  }, 1e3)
);
function li(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var tt = { exports: {} }, ui = tt.exports, nn;
function fi() {
  return nn || (nn = 1, function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(ui, function() {
      var n = 1e3, r = 6e4, s = 36e5, i = "millisecond", c = "second", o = "minute", l = "hour", p = "day", _ = "week", a = "month", g = "quarter", m = "year", S = "date", O = "Invalid Date", V = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, U = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(d) {
        var f = ["th", "st", "nd", "rd"], u = d % 100;
        return "[" + d + (f[(u - 20) % 10] || f[u] || f[0]) + "]";
      } }, F = function(d, f, u) {
        var v = String(d);
        return !v || v.length >= f ? d : "" + Array(f + 1 - v.length).join(u) + d;
      }, b = { s: F, z: function(d) {
        var f = -d.utcOffset(), u = Math.abs(f), v = Math.floor(u / 60), h = u % 60;
        return (f <= 0 ? "+" : "-") + F(v, 2, "0") + ":" + F(h, 2, "0");
      }, m: function d(f, u) {
        if (f.date() < u.date()) return -d(u, f);
        var v = 12 * (u.year() - f.year()) + (u.month() - f.month()), h = f.clone().add(v, a), y = u - h < 0, w = f.clone().add(v + (y ? -1 : 1), a);
        return +(-(v + (u - h) / (y ? h - w : w - h)) || 0);
      }, a: function(d) {
        return d < 0 ? Math.ceil(d) || 0 : Math.floor(d);
      }, p: function(d) {
        return { M: a, y: m, w: _, d: p, D: S, h: l, m: o, s: c, ms: i, Q: g }[d] || String(d || "").toLowerCase().replace(/s$/, "");
      }, u: function(d) {
        return d === void 0;
      } }, R = "en", P = {};
      P[R] = U;
      var Z = "$isDayjsObject", Me = function(d) {
        return d instanceof Q || !(!d || !d[Z]);
      }, de = function d(f, u, v) {
        var h;
        if (!f) return R;
        if (typeof f == "string") {
          var y = f.toLowerCase();
          P[y] && (h = y), u && (P[y] = u, h = y);
          var w = f.split("-");
          if (!h && w.length > 1) return d(w[0]);
        } else {
          var T = f.name;
          P[T] = f, h = T;
        }
        return !v && h && (R = h), h || !v && R;
      }, x = function(d, f) {
        if (Me(d)) return d.clone();
        var u = typeof f == "object" ? f : {};
        return u.date = d, u.args = arguments, new Q(u);
      }, N = b;
      N.l = de, N.i = Me, N.w = function(d, f) {
        return x(d, { locale: f.$L, utc: f.$u, x: f.$x, $offset: f.$offset });
      };
      var Q = function() {
        function d(u) {
          this.$L = de(u.locale, null, !0), this.parse(u), this.$x = this.$x || u.x || {}, this[Z] = !0;
        }
        var f = d.prototype;
        return f.parse = function(u) {
          this.$d = function(v) {
            var h = v.date, y = v.utc;
            if (h === null) return /* @__PURE__ */ new Date(NaN);
            if (N.u(h)) return /* @__PURE__ */ new Date();
            if (h instanceof Date) return new Date(h);
            if (typeof h == "string" && !/Z$/i.test(h)) {
              var w = h.match(V);
              if (w) {
                var T = w[2] - 1 || 0, $ = (w[7] || "0").substring(0, 3);
                return y ? new Date(Date.UTC(w[1], T, w[3] || 1, w[4] || 0, w[5] || 0, w[6] || 0, $)) : new Date(w[1], T, w[3] || 1, w[4] || 0, w[5] || 0, w[6] || 0, $);
              }
            }
            return new Date(h);
          }(u), this.init();
        }, f.init = function() {
          var u = this.$d;
          this.$y = u.getFullYear(), this.$M = u.getMonth(), this.$D = u.getDate(), this.$W = u.getDay(), this.$H = u.getHours(), this.$m = u.getMinutes(), this.$s = u.getSeconds(), this.$ms = u.getMilliseconds();
        }, f.$utils = function() {
          return N;
        }, f.isValid = function() {
          return this.$d.toString() !== O;
        }, f.isSame = function(u, v) {
          var h = x(u);
          return this.startOf(v) <= h && h <= this.endOf(v);
        }, f.isAfter = function(u, v) {
          return x(u) < this.startOf(v);
        }, f.isBefore = function(u, v) {
          return this.endOf(v) < x(u);
        }, f.$g = function(u, v, h) {
          return N.u(u) ? this[v] : this.set(h, u);
        }, f.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, f.valueOf = function() {
          return this.$d.getTime();
        }, f.startOf = function(u, v) {
          var h = this, y = !!N.u(v) || v, w = N.p(u), T = function(he, W) {
            var oe = N.w(h.$u ? Date.UTC(h.$y, W, he) : new Date(h.$y, W, he), h);
            return y ? oe : oe.endOf(p);
          }, $ = function(he, W) {
            return N.w(h.toDate()[he].apply(h.toDate("s"), (y ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(W)), h);
          }, C = this.$W, j = this.$M, J = this.$D, ye = "set" + (this.$u ? "UTC" : "");
          switch (w) {
            case m:
              return y ? T(1, 0) : T(31, 11);
            case a:
              return y ? T(1, j) : T(0, j + 1);
            case _:
              var pe = this.$locale().weekStart || 0, Re = (C < pe ? C + 7 : C) - pe;
              return T(y ? J - Re : J + (6 - Re), j);
            case p:
            case S:
              return $(ye + "Hours", 0);
            case l:
              return $(ye + "Minutes", 1);
            case o:
              return $(ye + "Seconds", 2);
            case c:
              return $(ye + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, f.endOf = function(u) {
          return this.startOf(u, !1);
        }, f.$set = function(u, v) {
          var h, y = N.p(u), w = "set" + (this.$u ? "UTC" : ""), T = (h = {}, h[p] = w + "Date", h[S] = w + "Date", h[a] = w + "Month", h[m] = w + "FullYear", h[l] = w + "Hours", h[o] = w + "Minutes", h[c] = w + "Seconds", h[i] = w + "Milliseconds", h)[y], $ = y === p ? this.$D + (v - this.$W) : v;
          if (y === a || y === m) {
            var C = this.clone().set(S, 1);
            C.$d[T]($), C.init(), this.$d = C.set(S, Math.min(this.$D, C.daysInMonth())).$d;
          } else T && this.$d[T]($);
          return this.init(), this;
        }, f.set = function(u, v) {
          return this.clone().$set(u, v);
        }, f.get = function(u) {
          return this[N.p(u)]();
        }, f.add = function(u, v) {
          var h, y = this;
          u = Number(u);
          var w = N.p(v), T = function(j) {
            var J = x(y);
            return N.w(J.date(J.date() + Math.round(j * u)), y);
          };
          if (w === a) return this.set(a, this.$M + u);
          if (w === m) return this.set(m, this.$y + u);
          if (w === p) return T(1);
          if (w === _) return T(7);
          var $ = (h = {}, h[o] = r, h[l] = s, h[c] = n, h)[w] || 1, C = this.$d.getTime() + u * $;
          return N.w(C, this);
        }, f.subtract = function(u, v) {
          return this.add(-1 * u, v);
        }, f.format = function(u) {
          var v = this, h = this.$locale();
          if (!this.isValid()) return h.invalidDate || O;
          var y = u || "YYYY-MM-DDTHH:mm:ssZ", w = N.z(this), T = this.$H, $ = this.$m, C = this.$M, j = h.weekdays, J = h.months, ye = h.meridiem, pe = function(W, oe, Ve, Je) {
            return W && (W[oe] || W(v, y)) || Ve[oe].slice(0, Je);
          }, Re = function(W) {
            return N.s(T % 12 || 12, W, "0");
          }, he = ye || function(W, oe, Ve) {
            var Je = W < 12 ? "AM" : "PM";
            return Ve ? Je.toLowerCase() : Je;
          };
          return y.replace(I, function(W, oe) {
            return oe || function(Ve) {
              switch (Ve) {
                case "YY":
                  return String(v.$y).slice(-2);
                case "YYYY":
                  return N.s(v.$y, 4, "0");
                case "M":
                  return C + 1;
                case "MM":
                  return N.s(C + 1, 2, "0");
                case "MMM":
                  return pe(h.monthsShort, C, J, 3);
                case "MMMM":
                  return pe(J, C);
                case "D":
                  return v.$D;
                case "DD":
                  return N.s(v.$D, 2, "0");
                case "d":
                  return String(v.$W);
                case "dd":
                  return pe(h.weekdaysMin, v.$W, j, 2);
                case "ddd":
                  return pe(h.weekdaysShort, v.$W, j, 3);
                case "dddd":
                  return j[v.$W];
                case "H":
                  return String(T);
                case "HH":
                  return N.s(T, 2, "0");
                case "h":
                  return Re(1);
                case "hh":
                  return Re(2);
                case "a":
                  return he(T, $, !0);
                case "A":
                  return he(T, $, !1);
                case "m":
                  return String($);
                case "mm":
                  return N.s($, 2, "0");
                case "s":
                  return String(v.$s);
                case "ss":
                  return N.s(v.$s, 2, "0");
                case "SSS":
                  return N.s(v.$ms, 3, "0");
                case "Z":
                  return w;
              }
              return null;
            }(W) || w.replace(":", "");
          });
        }, f.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, f.diff = function(u, v, h) {
          var y, w = this, T = N.p(v), $ = x(u), C = ($.utcOffset() - this.utcOffset()) * r, j = this - $, J = function() {
            return N.m(w, $);
          };
          switch (T) {
            case m:
              y = J() / 12;
              break;
            case a:
              y = J();
              break;
            case g:
              y = J() / 3;
              break;
            case _:
              y = (j - C) / 6048e5;
              break;
            case p:
              y = (j - C) / 864e5;
              break;
            case l:
              y = j / s;
              break;
            case o:
              y = j / r;
              break;
            case c:
              y = j / n;
              break;
            default:
              y = j;
          }
          return h ? y : N.a(y);
        }, f.daysInMonth = function() {
          return this.endOf(a).$D;
        }, f.$locale = function() {
          return P[this.$L];
        }, f.locale = function(u, v) {
          if (!u) return this.$L;
          var h = this.clone(), y = de(u, v, !0);
          return y && (h.$L = y), h;
        }, f.clone = function() {
          return N.w(this.$d, this);
        }, f.toDate = function() {
          return new Date(this.valueOf());
        }, f.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, f.toISOString = function() {
          return this.$d.toISOString();
        }, f.toString = function() {
          return this.$d.toUTCString();
        }, d;
      }(), Ue = Q.prototype;
      return x.prototype = Ue, [["$ms", i], ["$s", c], ["$m", o], ["$H", l], ["$W", p], ["$M", a], ["$y", m], ["$D", S]].forEach(function(d) {
        Ue[d[1]] = function(f) {
          return this.$g(f, d[0], d[1]);
        };
      }), x.extend = function(d, f) {
        return d.$i || (d(f, Q, x), d.$i = !0), x;
      }, x.locale = de, x.isDayjs = Me, x.unix = function(d) {
        return x(1e3 * d);
      }, x.en = P[R], x.Ls = P, x.p = {}, x;
    });
  }(tt)), tt.exports;
}
var di = fi();
const pi = /* @__PURE__ */ li(di), nt = {
  maxLength: 5,
  waitTime: 5e3,
  cacheMaxLength: 3e3,
  cacheKey: "tracing-event"
}, B = { isLogin: !1 }, ft = /* @__PURE__ */ new Map(), Ce = /* @__PURE__ */ new Map(), te = ni(nt.cacheKey, [], {
  listenToStorageChanges: !0
});
let rn = !0;
function _i(e) {
  if (!e) throw "login error";
  Ae = "", Object.assign(B, { ...e, isLogin: !0 }), rn && (rn = !1, tr(), nr(), te.value.length > 0 && It());
}
function vi() {
  B.isLogin = !1;
}
let Nt = null, Ae;
async function Jn(e, t, n) {
  var o, l;
  if (!B.isLogin) return;
  ne.inactivityFlag && (t = 40), n ? Ae = n.order_no : Ae && ((o = e.func_dialogs) != null && o.length) && [10, 40].includes(t) ? n = ft.get(Ae) : Ae = "";
  const r = (l = Ce.get(Oe())) == null ? void 0 : l.title;
  n || (n = { order_oper: !1 });
  const s = pi(), i = +s, c = {
    ...Gn(),
    func_menu: `${Oe()}${r ? `/${r}` : ""}`,
    func_interval_time: ai(i),
    ...e,
    ...n,
    event_time: s.format("YYYY-MM-DD HH:mm:ss"),
    event_timestamp: i,
    event_year: s.year(),
    event_month: s.format("YYYYMM"),
    event_type: t,
    system_id: B.systemId
  };
  ci(i), gi(c);
}
function hi(e, t = "") {
  if (!e) return;
  const n = Qn();
  Jn(
    {
      func_button: e.replaceAll(" ", ""),
      func_dialogs: n.join("->"),
      func_dialog_level: n.length
    },
    10,
    ft.get(t)
  );
}
function qn(e) {
  Jn(e, 20);
}
function gi(e) {
  console.log(e), te.value.length >= nt.cacheMaxLength && te.value.shift(), te.value.push(e), te.value.length >= nt.maxLength ? It() : (clearTimeout(Nt), Nt = setTimeout(() => {
    It(), Nt = null;
  }, nt.waitTime));
}
async function It() {
  if (te.value.length > 0 && B.isLogin) {
    const e = [...te.value];
    te.value.length = 0;
    try {
      await rr({
        systemId: B.systemId,
        bzType: B.userInfo.businessType,
        eventClickLogs: e
      });
    } catch {
      te.value.push(...e);
    }
  }
}
export {
  Ce as childMenuMap,
  _i as loginSDK,
  vi as logoutSDK,
  nt as options,
  ft as orderMap,
  mi as saveAxios,
  hi as traceClickEvent,
  qn as tracePageView,
  B as webParams
};
